import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { HeaderItem } from 'components/misc'
import { AssessorGuideModal } from 'components/modals'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'

@modal.trigger()
@connect(({ api }) => ({
  award: get(api, 'dashboard.awards.awards.data')
}))
class AssessorGuide extends PureComponent {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    award: PropTypes.object,
    onlyTrigger: PropTypes.bool
  }

  render() {
    const { onlyTrigger, onClose } = this.props

    return (
      <div>
      <div onClick={() => this.props.onOpen(MODALS.ASSESSOR_GUIDE)}>
        <HeaderItem
          ico="info"
          caption="Guidelines"
          captionKey="label.assessor_guidelines"
        />

      </div>
        {!onlyTrigger &&
        <AssessorGuideModal
          modalId={MODALS.ASSESSOR_GUIDE}
          award={this.props.award}
          onClose={onClose}
        />}
      </div>
    )
  }
}

export default AssessorGuide
